import React from 'react';
import cx from 'classnames';
import {EntityType} from '../../features/Form/consts/EntityTypes';
import styles from './styles.module.scss';
import {getEntityIcon} from './actionIconData';
import {Icon} from '@priority-software/priority-style-react';

export type Props = {
    type: EntityType;
    componentClasses?: string;
    imgClasses?: string;
    disabled?: boolean;
    style?: React.CSSProperties;
    rounded?: boolean;
    iconSize?: 'small' | 'default';
};

export const ActionIcon = ({type, componentClasses, disabled, style, rounded, iconSize}: Props) => {
    const iconData = getEntityIcon(type);
    const SvgIcon = iconData.img;

    return (
        <div
            className={cx(styles.wrapper, iconData.className, componentClasses, {
                [styles.disabled]: disabled,
                [styles.rounded]: rounded
            })}
            style={style}
        >
            {iconData.icon ? (
                <Icon size={iconSize} icon={iconData.icon} componentClasses={styles.icon} />
            ) : (
                <SvgIcon />
            )}
        </div>
    );
};
